import { initialState } from "us.collection.admin/reducers/NonProductionDays/State";
import { NonProductionDay } from "us.collection.admin/constants/Actions";
import {
  addOrUpdateRedDayRelevantCriteria,
} from "us.collection.admin/functions";
import _ from "lodash";

const {
  GET_NON_PRODUCTION_DAYS,
  GET_NON_PRODUCTION_DAYS_SUCCESS,
  GET_NON_PRODUCTION_DAYS_FAIL,
  SAVE_NON_PRODUCTION_DAYS,
  MANAGE_TABS,
  GET_SCHEDULES_TIME_SLOTS,
  GET_SCHEDULES_TIME_SLOTS_FAIL,
  GET_SCHEDULES_TIME_SLOTS_SUCCESS,
  DELETE_NON_PRODUCTION_DAYS,
  INIT_NON_PRODUCTION,
  INIT_NON_PRODUCTION_SUCCESS,
  INIT_NON_PRODUCTION_FAIL,
  SAVE_CALENDAR,
  SAVE_CALENDAR_SUCCESS,
  SAVE_CALENDAR_FAIL,
  SAVE_NON_PRODUCTION_DAYS_SUCCESS
} = NonProductionDay;


export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case SAVE_NON_PRODUCTION_DAYS_SUCCESS:
      const { data } = payload
      return Object.assign({}, state, {
        redDays: {
          ...state.redDays,
          data: addOrUpdateRedDayRelevantCriteria(state?.redDays?.data, data)
        },
      });
    case MANAGE_TABS:
      return Object.assign({}, state, {
        selectedCriteria: payload.data.selectedCriteria
      });
    case INIT_NON_PRODUCTION:
      return Object.assign({}, state, {
        scheduleTime: {
          data: [],
          nonSms: [],
          nonEmail: [],
          nonPrinting: [],
          isFetching: true,
        },
        redDays: {
          data: [],
          nonEhf: [],
          nonSms: [],
          nonPrinting: [],
          nonEmail: [],
          isFetching: true,
        }
      });

    case INIT_NON_PRODUCTION_FAIL:
      return Object.assign({}, state, {
        scheduleTime: {
          data: [],
          nonSms: [],
          nonEmail: [],
          nonPrinting: [],
          isFetching: false,
        },
        redDays: {
          data: [],
          nonEhf: [],
          nonSms: [],
          nonPrinting: [],
          nonEmail: [],
          isFetching: false,
        }
      })

    case GET_SCHEDULES_TIME_SLOTS:
      return Object.assign({}, state, {
        scheduleTime: {
          data: [],
          nonSms: [],
          nonEmail: [],
          nonPrinting: [],
          isFetching: true,
        },
      });
    case GET_SCHEDULES_TIME_SLOTS_SUCCESS:
      const { smsSchedules, emailSchedules, printingSchedules } = payload.data
      return Object.assign({}, state, {
        scheduleTime: {
          data: payload.data,
          nonSms: smsSchedules,
          nonEmail: emailSchedules,
          nonPrinting: printingSchedules,
          isFetching: false,
        },
      });
    case GET_SCHEDULES_TIME_SLOTS_FAIL:
      return Object.assign({}, state, {
        scheduleTime: {
          data: [],
          nonSms: [],
          nonEmail: [],
          nonPrinting: [],
          isFetching: false,
        },
      })
 
    case GET_NON_PRODUCTION_DAYS:
      return Object.assign({}, state, {
        redDays: {
          data: state?.redDays?.data,
          isFetching: true,
        }
      })
    case GET_NON_PRODUCTION_DAYS_SUCCESS:
      return Object.assign({}, state, {
        redDays: {
          data: payload.data,
          isFetching: false
        },
      })
    case GET_NON_PRODUCTION_DAYS_FAIL:
      return Object.assign({}, state, {
        redDays: {
          data: state?.redDays?.data,
          isFetching: false,
        }
      })
    case SAVE_CALENDAR:
      return Object.assign({}, state, {
        isSubmitting: true
      })
    case SAVE_CALENDAR_SUCCESS:
      return Object.assign({}, state, {
        isSubmitting: false
      })
    case SAVE_CALENDAR_FAIL:
      return Object.assign({}, state, {
        isSubmitting: false
      })
    default:
      return state;
  }
};
